

(function ($) {
    $(function () {

        if ($('.js-favorite-post').length) {
            $('.js-favorite-post').on('click', function (e) {
                e.preventDefault();
                var post_id = $(this).data('post-id');
                var self = $(this);
                $.ajax({
                    type: 'POST',
                    url: localize.ajaxurl,
                    data: {
                        action: 'favorite_post',
                        post_id: post_id,
                    },
                    success: function (response) {
                        if (response.success) {
                            if (response.data.action === 'favorited') {
                                self.find('.js-favorite-text').text('Saved article');
                                self.addClass('active');
                            } else {
                                self.find('.js-favorite-text').text('Save article');
                                self.removeClass('active');
                            }
                        } else {
                            alert(response.data);
                        }
                    },
                    error: function () {
                        alert('Error saving post');
                    },
                });
            });
        }
    });
})(jQuery);